/* ================ Navigation ================ */

$(document).ready(function(){

  $(".mobile-navigation-button").click(function(){
    $(".mobile-navigation").toggle();
    $(".mobile-navigation-button").toggleClass("mobile-nav-close");
  });

  $(".nav-close").click(function(){
  $(".nav-container").toggle();
  });

  $(".account-navigation-button").click(function(){
    $(".account-navigation").toggle();
  });


});

$(document).mouseup(function (e){

	var accontainer = $(".account-navigation");

	if (!accontainer.is(e.target) && accontainer.has(e.target).length === 0){

		accontainer.fadeOut();

	}
});

$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

/* collection thumbnails */
$('.collection-item').on("click", "a.thumbnail", function(e){
var src = $(this).attr('href');
var img = $(e.delegateTarget).find("img").first();
if (src != img.attr('src').replace(/\\?(.*)/,'')){
 img.stop().animate({ opacity: '0' },200, function(){
     $(this).attr('src', src);
   }).load(function(){ $(this).stop().animate({ opacity: '1' },200);
 });
}
return false;
});


$(document).ready(function($) {
  $(window).resize(function() {
      $('.collection-loop-banner').css("height", $(".product-loop-item").height());
  }).resize();

});
